package com.jingfangpai.common.data.response

import com.jingfangpai.common.constant.Error
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.KSerializer
import kotlinx.serialization.SerializationException
import kotlinx.serialization.Serializer
import kotlinx.serialization.builtins.nullable
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.descriptors.buildClassSerialDescriptor
import kotlinx.serialization.encoding.CompositeDecoder
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

@OptIn(ExperimentalSerializationApi::class)
@Serializer(forClass = ApiResponse::class)
class ApiResponseSerializer<T : Any>(private val dataSerializer: KSerializer<T>) : KSerializer<ApiResponse<T>> {
    override val descriptor: SerialDescriptor = buildClassSerialDescriptor("ApiResponseSerializer") {
        val dataDescriptor = dataSerializer.nullable.descriptor
        element("data", dataDescriptor)
        element("error", Error.serializer().descriptor)
        element("message", String.serializer().nullable.descriptor)
    }

    override fun serialize(encoder: Encoder, value: ApiResponse<T>) {
        val out = encoder.beginStructure(descriptor)
        out.encodeNullableSerializableElement(descriptor, 0, dataSerializer, value.data)
        out.encodeNullableSerializableElement(descriptor, 1, Error.serializer(), value.error)
        out.encodeNullableSerializableElement(descriptor, 2, String.serializer(),value.message)

        out.endStructure(descriptor)
    }

    override fun deserialize(decoder: Decoder): ApiResponse<T> {
        val inp = decoder.beginStructure(descriptor)
        var data: T? = null
        lateinit var error: Error
        var message: String? = null
        loop@ while (true) {
            when (val i = inp.decodeElementIndex(descriptor)) {
                CompositeDecoder.DECODE_DONE -> break@loop
                0 -> data = inp.decodeNullableSerializableElement(descriptor, i, dataSerializer.nullable)
                1 -> error = inp.decodeSerializableElement(descriptor, i, Error.serializer())
                2 -> message = inp.decodeNullableSerializableElement(descriptor, i, String.serializer().nullable)
                else -> throw SerializationException("Unknown index $i")
            }
        }
        inp.endStructure(descriptor)
        return ApiResponse(data,error,message)
    }
}
